module.exports = __webpack_public_path__ + "static/media/news_head_bg.f0444598.jpg";